/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: @loopback/repository-json-schema#Optional<Omit<SurveyResponses, \'id\'>, \'surveyId\'>, schemaOptions: { title: \'NewSurveyResponsesInSurveys\', exclude: [ \'id\' ], optional: [ \'surveyId\' ] })
 */
export interface NewSurveyResponsesInSurveys { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    surveyId?: string;
    questionId?: string;
    score: number;
    scoreDisplay: number;
    includeInAverage?: boolean;
}

